import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const anchors = [
  { href: '#story', label: '專案故事' },
  { href: '#concepts', label: '本書內容' },
  { href: '#specs', label: '書籍規格' },
  { href: '#portal', label: 'RG Portal' },
  { href: '#rewards', label: '回饋方案' },
  { href: '#funding', label: '資金時程' },
  { href: '#faq', label: '常見問題' },
];

export default function RgHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-sm border-b border-foreground-100/60'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <nav className="max-w-6xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-baseline cursor-pointer whitespace-nowrap">
          <span
            className="text-base md:text-lg tracking-wide text-foreground-900"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            AUM1001 Matrix
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-0.5">
          {anchors.map((a) => (
            <a
              key={a.href}
              href={a.href}
              className="whitespace-nowrap px-3 py-2 text-sm text-foreground-600 hover:text-foreground-900 hover:bg-foreground-50 rounded-md transition-colors cursor-pointer"
            >
              {a.label}
            </a>
          ))}
          <Link
            to="/"
            className="whitespace-nowrap px-4 py-2 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer ml-1"
          >
            回到首頁
          </Link>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700 cursor-pointer"
          aria-label="開啟選單"
        >
          <i className={`ri-${open ? 'close' : 'menu'}-line text-xl`} />
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-foreground-100/60 bg-background-50 px-4 py-3 flex flex-col gap-0.5">
          {anchors.map((a) => (
            <a
              key={a.href}
              href={a.href}
              onClick={() => setOpen(false)}
              className="px-3 py-2.5 rounded-md text-sm text-foreground-600 hover:bg-foreground-50 cursor-pointer whitespace-nowrap"
            >
              {a.label}
            </a>
          ))}
          <Link
            to="/"
            onClick={() => setOpen(false)}
            className="px-3 py-2.5 rounded-md text-sm text-primary-800 bg-primary-100 cursor-pointer whitespace-nowrap mt-1"
          >
            回到首頁
          </Link>
        </div>
      )}
    </header>
  );
}
